module.exports = "https://static.energy5.com/_next/static/images/retailEnergy-2b2fa056d45a7611ea5273d315186549.webp";